import { render, staticRenderFns } from "./HistoricoAlteracaoList.vue?vue&type=template&id=862098bc"
import script from "./HistoricoAlteracaoList.vue?vue&type=script&lang=js"
export * from "./HistoricoAlteracaoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports